import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { useList } from './useList';
import { useTranslate } from './useTranslate';
import { useMouseEvents } from './useMouseEvents';
import { useConfigContext } from '../config';
var typeDefs = {
  value: null,
  count: Number,
  data: [Array, Function],
  disabled: Boolean,
  disable: Function
};
var defaults = function defaults() {
  return {
    count: 19,
    data: []
  };
};
export var ScrollSelect = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ScrollSelect, _Component);
  function ScrollSelect() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.list = useList();
    _this.translate = useTranslate();
    _this.mouseEvents = useMouseEvents(_this.translate.translate, _this.list);
    _this.config = useConfigContext();
    return _this;
  }
  return ScrollSelect;
}(Component);
ScrollSelect.template = template;
ScrollSelect.typeDefs = typeDefs;
ScrollSelect.defaults = defaults;